const initialState = {
    responseLandingList: {},
    responseLanding: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "LANDING_LIST_RESPONSE":
            newState.responseLandingList = action.value
            break;
        case "LANDING_RESPONSE":
            newState.responseLanding = action.value
            break;
        default: 
            return newState;
    }

    return newState;
};

export default reducer;